import {ResearchLitElement, html, css, unsafeHTML} from '@core/research-lit-element';
import '@bog-design-system/bd-font';
import '@bog-design-system/bd-accordion';

class ResearchFaq extends ResearchLitElement {
    static get is() {
        return 'research-faq';
    }

    static get styles() {
        return css`
            :host {
                --title-margin-bottom: var(--space-32);
                --justify-title: flex-start;
                --box-shadow: var(--shadow-raised);
                --stroke-color: var(--color-invert-component-tr-60);
                ---border-radius: var(--border-radius-38);
                --accordion-header-bg: var(--color-invert-background-solid-10);
                --accordion-h-right-padding: var(--space-24);
                --accordion-article-bg: var(--color-invert-background-solid-10);
                ---accordion-h-padding: 0px;
                --article-padding: 0px 0px var(--space-24) 0px;
                --accordion-padding: 0px;
                --accordion-padding-left: 0px;
                --first-header-text-padding: 0px;
                --last-header-text-padding: 0px;
                --last-accordion-c-border: transparent;
                --faq-padding: var(--space-24) var(--space-80);
                --accordion-h-expanded-border: transparent;
                --first-last-border-radius: 0px;
            }

            :host([compact]) {
                --margin: 0 auto;
                --faq-padding: var(--space-24) var(--space-64);
            }

            :host([classic]) {
                ---border-radius: var(--border-radius-32);
                --accordion-article-bg: var(--color-invert-background-solid-30);
                --article-padding: var(--sapce-24);
                --accordion-padding-left: var(--space-24);
                --last-accordion-c-border: var(--color-invert-component-tr-70);
                --faq-padding: 0px;
                --accordion-h-expanded-border: var(--color-invert-component-tr-70);
                --first-last-border-radius: var(---border-radius);
            }

            .accordion-wrapper {
                display: flex;
                flex-direction: column;
            }

            :host([compact]) .accordion-wrapper {
                max-width: 1076px;
                margin: var(--margin);
            }

            .faq-title {
                margin-bottom: var(--title-margin-bottom);
                display: flex;
                justify-content: var(--justify-title);
            }

            .faq-title h3 {
                margin: 0;
                text-align: var(--justify-title);
            }

            .accordion-container {
                border-radius: var(---border-radius);
                padding: var(--faq-padding);
            }

            :host([shadow]) .accordion-container {
                box-shadow: var(--box-shadow);
            }

            :host([stroke]) .accordion-container {
                border: 1px solid var(--stroke-color);
            }

            .accordion {
                --accordion-h-bg: var(--accordion-header-bg);
                --accordion-h-padding-right: var(--accordion-h-right-padding);
                --header-bg-hover: transparent;
                --header-bg-active: transparent;
                --accordion-h-min-height: var(--space-72);
                --accordion-h-padding: var(---accordion-h-padding, 0px);
                padding: var(--accordion-padding, 0px);
                --padding-left: var(--accordion-padding-left, 0px);
                --accordion-expanded-h-border: var(--accordion-h-expanded-border);
            }

            .accordion:last-of-type {
                --content-border-color: var(---content-last-border-color, var(--last-accordion-c-border));
            }

            .accordion:first-of-type {
                border-top-left-radius: var(--first-last-border-radius);
                border-top-right-radius: var(--first-last-border-radius);
            }

            .accordion:first-of-type .faq-accordion-title {
                padding: var(--first-header-text-padding, 0px);
            }

            .accordion:last-of-type {
                border-bottom-left-radius: var(--first-last-border-radius);
                border-bottom-right-radius: var(--first-last-border-radius);
                --accordion-c-border: var(--last-accordion-c-border);
            }

            .accordion:last-of-type .faq-accordion-title {
                padding: var(--last-header-text-padding, 0px);
            }

            .article {
                padding: var(--article-padding, var(--space-24));
                color: var(--color-invert-component-tr-20);
                background-color: var(--accordion-article-bg);
            }

            .faq-accordion-title,
            .faq-accordion-description {
                color: var(--color-invert-component-tr-20);
            }

            .accordion:last-of-type {
                --content-border-radius: 0 0 var(--first-last-border-radius) var(--first-last-border-radius);
            }
            .accordion:last-of-type .article:last-of-type {
                border-bottom-left-radius: var(---border-radius-article-bottom, var(--first-last-border-radius));
                border-bottom-right-radius: var(---border-radius-article-bottom, var(--first-last-border-radius));
            }

            .hidden-schema {
                display: none;
            }

            @media (max-width: 1024px) {
                :host {
                    --faq-padding: var(--space-24) var(--space-64);
                }

                :host([classic]) {
                    --faq-padding: 0px;
                }
            }

            @media (max-width: 768px) {
                :host {
                    --title-margin-bottom: var(--space-24);
                    --faq-padding: var(--space-16) var(--space-64);
                }

                :host([compact]) {
                    --faq-padding: var(--space-16) var(--space-64);
                }

                :host([classic]) {
                    --faq-padding: 0px;
                }

                .faq-title {
                    margin-bottom: var(--title-margin-bottom);
                }

                .accordion {
                    --accordion-h-min-height: calc(var(--space-72) - var(--space-2));
                }
            }

            @media (max-width: 600px) {
                :host {
                    --title-margin-bottom: var(--space-24);
                    --faq-padding: var(--space-8) var(--space-24);
                    --accordion-h-right-padding: 0px;
                    --title-font-size: calc(var(--space-16) + var(--space-4));
                }

                :host([compact]) {
                    --faq-padding: var(--space-8) var(--space-24);
                }

                :host([classic]) {
                    --faq-padding: 0px;
                    --accordion-h-right-padding: var(--space-24);
                }

                .faq-title {
                    margin-bottom: var(--title-margin-bottom);
                }

                .faq-title h3 {
                    font-size: var(--title-font-size);
                }

                .accordion {
                    --accordion-h-padding: var(--space-16) 0px;
                }
            }
        `;
    }

    render() {
        return html`
            <div class="accordion-wrapper">
                <bd-font type="${this.titleType}" class="faq-title">
                    <h3>${this.data.faqTitle}</h3>
                </bd-font>
                <div class="accordion-container">
                    ${this.data &&
                    this.data.faq &&
                    this.data.faq.map(
                        (item) => html` <bd-accordion
                            class="accordion"
                            @accordion-opened="${(e) => e.target.classList.add('opened-accordion')}"
                            @accordion-closed="${(e) => e.target.classList.remove('opened-accordion')}"
                        >
                            <bd-font slot="header-center" type="subtitle" class="faq-accordion-title">
                                <h4>${item.title}</h4>
                            </bd-font>

                            <article slot="content" class="article">
                                <bd-font type="body2" class="faq-accordion-description">
                                    <p>${item.htmlText ? unsafeHTML(item.htmlText) : item.text ? item.text : ''}</p>
                                </bd-font>
                            </article>
                        </bd-accordion>`
                    )}
                </div>
            </div>
            ${this.data?.faq?.length > 0 ? this._getFAQSchema() : ''}
        `;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
            stroke: {
                type: Boolean,
                reflect: true,
            },
            shadow: {
                type: Boolean,
                reflect: true,
            },
            compact: {
                type: Boolean,
                reflect: true,
            },
            classic: {
                type: Boolean,
                reflect: true,
            },
            titleType: {
                type: String,
                reflect: true,
                attribute: 'title-type',
            },
        };
    }

    constructor() {
        super();

        this.classic = false;
        this.titleType = 'h3';
    }

    connectedCallback() {
        super.connectedCallback();
    }

    update(changedProperties) {
        super.update(changedProperties);
    }

    _getFAQSchema() {
        const faqSchema = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': [],
        };
        this.data?.faq.map((item) => {
            faqSchema.mainEntity.push({
                '@type': 'Question',
                'name': item.title,
                'acceptedAnswer': {
                    '@type': 'Answer',
                    'text': item.htmlText ? this.removeTagsFromString(item.htmlText) : item.text ? item.text : '',
                },
            });
        });
        const schemaItem = document.getElementById('faq-schema-markup');
        if (schemaItem) {
            schemaItem.remove();
        }
        const _script = document.createElement('script');
        _script.type = 'application/ld+json';
        _script.id = 'faq-schema-markup';
        _script.innerHTML = JSON.stringify(faqSchema);
        document.getElementsByTagName('head')[0].appendChild(_script);
    }

    removeTagsFromString(inputString) {
        return inputString.replace(/<[^>]+>/g, '');
    }
}

window.customElements.define(ResearchFaq.is, ResearchFaq);
